module.exports = __webpack_public_path__ + "static/iphone-black-755314877992be51da6e768c12fc333c.png";